<template>
  <div class="validation-error small"
       v-if="foundUser">
    {{ $t('such_patient_already_exists_in_database') }}: [{{ foundUser.id }}] {{ foundUser.full_name }}
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue"
import {useStore} from "vuex"
import {PatientService} from "@/services/api/patient.api.service"

const props = defineProps({
  object: {
    type: Object
  }
})

const foundUser = ref(null)

const store = useStore()

const lastChangedField = computed(() => store.state.datatable.lastChangedField)

watch(lastChangedField, (val) => {
  if(['lname', 'fname', 'mname'].includes(val?.id)) {
    if(props.object.fname && props.object.lname) {
      PatientService.checkIfNameExists({
        patient_id: props.object?.id || null, // can be new user
        fname: props.object.fname,
        lname: props.object.lname,
        mname: props.object.mname,
      }).then(res => {
        foundUser.value = res.data.user
      }).catch(err => {
        console.log(err)
      })
    }
  }
})
</script>
